export class ShowSpinner {
    static readonly type = '[Spinner] Show Spinner';
}
export class HideSpinner {
    static readonly type = '[Spinner] Hide Spinner';
}

export class DestroySpinner {
    static readonly type = '[Spinner] Destroy Spinner';
}

export class ProcessChange {
    static readonly type = '[Spinner] Process Change';
    constructor(public percent: number) { }
}
